import { clsx } from 'clsx';

function Shimmer({ className }: { className?: string }) {
  return (
    <div className={clsx('animate-pulse rounded-lg bg-surface-3', className)} />
  );
}

export function SkeletonCard({ className }: { className?: string }) {
  return (
    <div className={clsx('rounded-xl border border-border bg-surface-1 p-5', className)}>
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <Shimmer className="h-3 w-24" />
          <Shimmer className="h-2 w-16" />
        </div>
        <Shimmer className="h-8 w-8 rounded-full" />
      </div>
      <div className="mt-4 space-y-2">
        <Shimmer className="h-2 w-full" />
        <Shimmer className="h-2 w-3/4" />
      </div>
    </div>
  );
}

export function SkeletonMetric({ className }: { className?: string }) {
  return (
    <div className={clsx('rounded-xl border border-border bg-surface-1 p-4', className)}>
      <Shimmer className="h-2 w-20 mb-3" />
      <Shimmer className="h-6 w-28 mb-2" />
      <Shimmer className="h-1 w-full" />
    </div>
  );
}

export function SkeletonList({ rows = 4, className }: { rows?: number; className?: string }) {
  return (
    <div className={clsx('space-y-3', className)}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3">
          <Shimmer className="h-8 w-8 shrink-0 rounded-full" />
          <div className="flex-1 space-y-1.5">
            <Shimmer className="h-2.5 w-3/5" />
            <Shimmer className="h-2 w-2/5" />
          </div>
          <Shimmer className="h-5 w-14 rounded-full" />
        </div>
      ))}
    </div>
  );
}
